import { remove } from '@webapp-next/lib/request/webapp/apiv2';

export default async function deleteShift(id) {
  try {
    const url = `/api/management/v2/shifts/${id}`;
    const data = await remove(url).then(res => res.data);
    return data.success;
  } catch (error) {
    console.error('deleteShift failed', error);
  }
}
